// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__39MIu","password":"PasswordResetForm_password__13Ezq"};